<template>
  <div class="list-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-cell-group class="subform">
			<van-cell title="申请人" :value="ADMIN.USER_NAME"/>
			<van-cell title="所属部门" :value="ADMIN.USER_DEPARTMENT_NAME" />
			<van-field
					readonly
					clickable
					required
					name="startDatetimePicker"
					:value="start_date"
					label="开始时间"
					:placeholder="'请选择开始时间'"
					:rules="[{ required: true, message: '' }]"
					@click="onSelectDate(1)"
			></van-field>
			<van-field
					readonly
					clickable
					required
					name="startDatetimePicker"
					:value="end_date"
					label="结束时间"
					:placeholder="'请选择结束时间'"
					:rules="[{ required: true, message: '' }]"
					@click="onSelectDate(2)"
			></van-field>
<!--			<van-cell class="required-x" title="开始时间" is-link arrow-direction="down" :value="start_date" @click="onSelectDate(1)" />-->
<!--			<van-cell class="required-x" title="结束时间" is-link arrow-direction="down" :value="end_date" @click="onSelectDate(2)" />-->
			<van-cell class="required-x" title="外出类型">
				<van-radio-group class="mt5" name="outCategory" v-model="outCategory" direction="horizontal">
				  <van-radio name="003">因公外出</van-radio>
				  <van-radio name="004">培训外出</van-radio>
				</van-radio-group>
			</van-cell>
			<van-cell title="外出原因" class="required-x">
				<van-cell-group>
				  <van-field
					class="textarea"
					rows="2"
					type="textarea"
					name="fTripReason"
					v-model="fTripReason"
				  />
				</van-cell-group>
			</van-cell>
			<!-- <van-cell title="同行人员" class="t-input">
				<van-field 
				    name="peerPerson"
				    placeholder=""
					v-model="peerPerson"
				  />
			</van-cell> -->
			<van-cell title="同行人员" class="t-input">
				<van-field 
				    name="peerPerson"
				    placeholder=""
					v-model="peerPerson"
				/>
			</van-cell>
			<!-- 用户隐藏框 -->
			<div class="search_show search_user van-cell">
				<div class="van-cell__title"><span></span></div>
				<div class="van-cell__value">
				</div>
			</div>
			<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
				<van-button @click="onSubmit()" type="info" size="large">提交</van-button>
			</div>
			<van-popup v-model="is_start_date_show" position="bottom" :style="{ height: '40%' }">
			  <van-datetime-picker 
			  v-model="start_currentDate" 
			  type="datetime" 
			  :min-date="minDate"
			  :max-date="maxDate"
			  @change="OnChangeDate()" 
			  @confirm="OnConfirmDate()" 
			  @cancel="OnCancelDate()" />
			</van-popup>
			<van-popup v-model="is_end_date_show" position="bottom" :style="{ height: '40%' }">
			  <van-datetime-picker 
			  v-model="end_currentDate" 
			  type="datetime" 
			  :min-date="minDate"
			  :max-date="maxDate"
			  @change="OnChangeDate()" 
			  @confirm="OnConfirmDate()" 
			  @cancel="OnCancelDate()" />
			</van-popup>
	</van-cell-group>
	<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>
<style lang="less">
	.van-cell__title{max-width: 22%;}
	.van-cell__value{text-align: left;}
	.last.van-cell:not(:last-child)::after{border-bottom:none;}
</style>
<script type="text/javascript">
import axios from 'axios';
export default {
	data() {
		return {
		  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
		  outCategory:"003",
		  fTripReason:"",
		  peerPerson:"",
		  is_date_type:1,
		  start_date:"",
		  end_date:"",
		  minDate: new Date(2020, 0, 1),
		  maxDate: new Date(2026, 12, 1),
		  start_currentDate: new Date(),
		  end_currentDate: new Date(),
		  is_start_date_show: false,
		  is_end_date_show: false,
		  search_name:"",
		 // radio: '1'
		};
    },
	mounted(){
		if(this.$route.query.sDate && this.$route.query.eDate){
			let st = new Date(this.$route.query.sDate.replace(/-/g,'/'));
			let et = new Date(this.$route.query.eDate.replace(/-/g,'/'));
			this.start_currentDate = st;
			this.end_currentDate = et;
			this.start_date = this.Common.timestampToTime(this.start_currentDate);
			this.end_date = this.Common.timestampToTime(this.end_currentDate);
		}
		if(this.$route.query.remark){
			this.fTripReason = this.$route.query.remark
		}

	},
    methods: {
		onSelectDate: function (i) {  
			if(i==2){
				this.is_date_type=2;this.is_start_date_show = false;
				this.is_end_date_show = true;
			}else{
				this.is_date_type=1;this.is_end_date_show = false;
				this.is_start_date_show = true;
			}
		},
		OnChangeDate: function () {
			//this.changeDate = this.currentDate ;
		},
		OnConfirmDate: function () {
			if(this.is_date_type==2){
				this.end_date = this.GetTimeFormat(this.end_currentDate);
			}else{
				this.start_date = this.GetTimeFormat(this.start_currentDate);
			}
			this.is_start_date_show = false;this.is_end_date_show = false;
		},
		OnCancelDate: function () {
			this.is_start_date_show = false;this.is_end_date_show = false;
		},
		GetTimeFormat: function (time) {// 时间格式化 2019-09-08
		   let y = time.getFullYear();
		   let MM = time.getMonth() + 1;
		   MM = MM < 10 ? ('0' + MM) : MM;
		   let d = time.getDate();
		   d = d < 10 ? ('0' + d) : d;
		   let h = time.getHours();
		   h = h < 10 ? ('0' + h) : h;
		   let m = time.getMinutes();
		   m = m < 10 ? ('0' + m) : m;
		   let s = time.getSeconds()<10 ? "0"+time.getSeconds() : time.getSeconds();
		   //s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' '+ h + ':' + m + ':' + s;
		},
		finish: function () {
			$(".sms-no").hide();
			$(".sms-yes").show();
			this.$refs.countDown.reset();
		},
		getTime:function(){
			var _this = this;
		    let yy = new Date().getFullYear();
		    let mm = new Date().getMonth()+1;
		    let dd = new Date().getDate();
		    let hh = new Date().getHours();
		    let mf = new Date().getMinutes()<10 ? "0"+new Date().getMinutes() : new Date().getMinutes();
		    let ss = new Date().getSeconds()<10 ? "0"+new Date().getSeconds() : new Date().getSeconds();
		    return yy+"-"+mm+"-"+dd;
		},
		onInputShow: function (id) {
			$(".search_user .van-cell__value").find(".input_show").remove();
			if(this.search_name!=""){
				axios.get(this.CoreNew.OA_API_IP+"joa-business/commonQuery/simpleUserQuery?limit=1200&keyword="+this.search_name,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
					var $rs=response.data;var str_html="";
					if($rs.flag==true){
						$(".search_show").show();
						var $list=$rs.data;var _str_html
						for (var i = 0; i < $list.length; i++) {
							str_html +="<li data-val='"+$list[i].cname+"'>"+$list[i].cname+"</li>";
						}
						$(".search_user .van-cell__value").find(".input_show").remove();
						$(".search_user .van-cell__value").append('<ul class="input_show">'+str_html+'</ul>');
						$(".search_user .van-cell__value").find(".input_show").show();
						var self = this;
						$(".search_user").find(".input_show li").click(function(){
							self.search_name=$(this).html();
							self.peerPerson=$(this).attr("data-val");
							$(".search_show").hide();
						})
					}else{
						$(".search_show").hide();
					}
				}.bind(this)).catch(function (error) { 
					//alert("请求--用户搜索--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--用户搜索--失败"+error);//记录错误
					console.log("请求--用户搜索--失败"+error);
				});
			}
		},
		onSubmit: function () {
			$(".search_show").hide();
			if(this.start_date == ''){
				this.$toast("开始时间不能为空"); return false; 
			} 
			if(this.end_date == ''){
				this.$toast("结束时间不能为空"); return false; 
			} 
			if(this.start_date > this.end_date){
				this.$toast("结束时间不能小于开始时间"); return false; 
			} 
			if(this.outCategory == ''){
				this.$toast("外出类型还没选择"); return false; 
			}
			if(this.fTripReason == ''){
				this.$toast("外出原因不能为空"); return false; 
			} 
			//提交
			$("#loading").show();
			let post_data = new FormData();
			post_data.append("types",this.outCategory);
			post_data.append("fTripReason",this.fTripReason);
			post_data.append("fTripStartTime",this.start_date);
			post_data.append("fTripEndTime",this.end_date);
			post_data.append("peerPerson",this.peerPerson);
			post_data.append("fTripStartPlace","出发地点");
			post_data.append("fTripEndPlace","目的地点");
			axios.post(this.CoreNew.OA_API_IP+"joa-business/tripBillApply",post_data,{
				headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
			}).then(function (response) {
				var $rs=JSON.parse(response.data.data);
				$("#loading").hide();
				if(response.data.flag==true && $rs.result==1){
					this.$toast("操作成功");
					var time = 2;
					var timer = setInterval(function() {
						time--;
						if(time == 0) {
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'apply?sys=ehr';
							clearInterval(timer);//清楚定时
						}
					}, 1000);
				}else{
					this.$toast($rs.errorMessage);
				}
			}.bind(this)).catch(function (error) { 
				//alert("请求EHR--保存外出申请--失败"+error);
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求EHR--保存外出申请--失败"+error);//记录错误
				console.log("请求EHR--保存外出申请--失败"+error);
			});
		}
    }
};
</script>